const enUS = {
  header: {
    title: `My Priorities Quiz`,
    link: `https://www.edwardjones.com`,
  },
  app: {
    skipLinkText: 'Skip to main content',
    customizePath: '/customize',
    quizPath: '/quiz',
    resultsPath: '/results',
    errorPath: '/error',
    planningPath: '/planning',
  },
  defaultDisclosure: `The My Priorities quiz is meant to help you start a conversation with your financial advisor about what matters most to you. It is intended to be used for illustrative purposes only, and the results will be based on the selections you make. The results are not intended to offer any financial advice, financial planning services, or constitute any recommendations. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within the quiz or results, please contact your branch to discuss.`,
  styleModalButton: `Okay, got it!`,
  welcomePage: {
    pageTitle: `My Priorities - Home`,
    header: `Welcome`,
    introPa: `The "My Priorities" quiz helps you compare your priorities.   The results help us get to know you better and dig deeper into the "whys."`,
    customizeInstr: `This three-minute quiz begins with customizing your choices to remove priorities least relevant to you. The quiz will then show you two priorities at a time, and you'll select the one that matters most to you. You may encounter two that feel equally important or some that don't feel applicable at all – but don't worry. What you value most will rise to the top.`,
    startBtnLabel: `Start the quiz`,
    customizeBtnLabel: `Customize your quiz`,
    welcomePageDisclosure: `The My Priorities quiz is meant to help you start a conversation with your financial advisor about what matters most to you. It is intended to be used for illustrative purposes only, and the results will be based on the selections you make. The results are not intended to offer any financial advice or constitute any recommendations. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within the quiz or results, please contact your branch to discuss.`,
  },
  fpWelcomePage: {
    pageTitle: `My Priorities - Home`,
    mainHeader: `What's your ideal life?`,
    mainHeaderParagraph: `Understanding your priorities is the first step to creating your ideal life. This activity will prepare you and your financial advisor to get the most value out of your time together.`,
    ctaSectionHeader: `Get started`,
    ctaSectionHeaderParagraphOneDefault: `This three-minute quiz begins with customizing your choices to remove priorities least relevant to you. The quiz will then show you two priorities at a time, and you'll select the one that matters most to you. You may encounter two that feel equally important or some that don't feel applicable at all – but don't worry. What you value most will rise to the top.`,
    ctaSectionHeaderParagraphOneAlternate: `In this quiz, you will complete a short activity to help us understand your ideal lifestyle and how your priorities contribute to a well-rounded life. Then, you will let us know what financial topics interest you, allowing us to have deeper conversations about your needs.`,
    ctaSectionHeaderParagraphTwo: `It is best to do this activity in a quiet place without distractions.`,
    startBtnLabel: `Start`,
    welcomePageDisclosure: `The My Priorities quiz is meant to help you start a conversation with your financial advisor about what matters most to you. It is intended to be used for illustrative purposes only, and the results will be based on the selections you make. The results are not intended to offer any financial advice, financial planning services, or constitute any recommendations. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within the quiz or results, please contact your branch to discuss.`,
  },
  customizePage: {
    pageTitle: `My Priorities - Customize Quiz`,
    header: `Customize your quiz`,
    description: `Deselect five of the below priorities that are least relevant to you. The quiz uses exactly 11 priorities, so you'll remove exactly five to start the quiz.`,
    startQuiz: `Next`,
    disabledBtnDefault: `Remove 5 more`,
    disabledBtnRemove: `Remove`,
    disabledBtnAdd: `Add`,
    disabledBtnMore: `more`,
    iconButton: 'Why 11?',
    modalTitle: `Why do I need exactly 11 priorities to start the quiz?`,
    modalParagraph1: `You may see more than 11 priorities that you value or you may see less. That's okay!`,
    modalParagraph2: `In order for our quiz to give you your most accurate ranking, it has to have exactly 11, so go with your gut, and do your best to narrow it down to that magic number.`,
    customPriorityInfoModalTitle: `Provide your own customized priority to be included in the quiz.`,
    writeInPlaceHolderText: `add your own priority`,
  },
  fpCustomizePage: {
    pageTitle: `My Priorities - Customize Quiz`,
    header: `Your Lifestyle Priorities`,
    description: `Select the 5 priorities that matter least to you and then select Next. This quiz uses exactly 11 lifestyle priorities, so you’ll remove five to get started.`,
    startQuiz: `Next`,
    disabledBtnDefault: `Remove 5 more`,
    disabledBtnRemove: `Remove`,
    disabledBtnAdd: `Add`,
    disabledBtnMore: `more`,
    iconButton: 'Why 11?',
    modalTitle: `Why do I need exactly 11 priorities to start the quiz?`,
    modalParagraph1: `You may see more than 11 priorities that you value or you may see less. That's okay!`,
    modalParagraph2: `In order for our quiz to give you your most accurate ranking, it has to have exactly 11, so go with your gut, and do your best to narrow it down to that magic number.`,
    customPriorityInfoModalTitle: `Provide your own customized priority to be included in the quiz.`,
    writeInPlaceHolderText: `add your own priority`,
    customizePageDisclosure: `The My Priorities quiz is meant to help you start a conversation with your financial advisor about what matters most to you. It is intended to be used for illustrative purposes only, and the results will be based on the selections you make. The results are not intended to offer any financial advice, financial planning services, or constitute any recommendations. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within the quiz or results, please contact your branch to discuss.`,
  },
  modalTitle: 'How does this quiz work?',
  modalParagraph1:
    "You'll compare two priorities by selecting the one that matters most to you. You may see priorities appear more than once or you may have to choose between two that feel equally important or may not be applicable right now - don't worry. What you value the most will rise to the top.",
  modalParagraph2:
    "It takes about 25 clicks to complete the quiz. When you're done, your financial advisor and you can discuss how your top priorities can ladder up to your long-term goals.",
  quizPage: {
    pageTitle: `My Priorities - Quiz`,
    header: `Which is a higher priority to you?`,
    tooltipDescription: `Compare the scenarios and click the square that feels more important to you. It's okay if neither one feels applicable. Just choose one and keep going. And don't worry if you see a priority appear more than once - that's how we get to what's most important to you.`,
    chooseOneBoldText: `Choose one priority. `,
    goWithText: `Go with your first reaction! Try to choose in less than 10 seconds.`,
    quizPageDisclosure: `The My Priorities quiz is meant to help you start a conversation with your financial advisor about what matters most to you. It is intended to be used for illustrative purposes only, and the results will be based on the selections you make. The results are not intended to offer any financial advice, financial planning services, or constitute any recommendations. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within the quiz or results, please contact your branch to discuss.`,
    ariaLabelChoiceNumberOne: `Choice number one is `,
    ariaLabelChoiceNumberTwo: `Choice number two is `,
    changePreviousAnswerButtonLabel: `Change Previous Answer`,
    changePreviousAnswerAriaLabel: `Change Previous Answer`,
    progressBarAriaLabel: `Question %QUESTION_NUMBER% of %MAX_QUESTIONS%.`,
  },
  planningTopicsPage: {
    pageTitle: `My Priorities - Financial Priorities`,
    header: `Financial priorities`,
    description: `Select at least one topic you would like to discuss with your financial advisor`,
    saveBtnLabel: `Save & Continue`,
    selectInvestmentDecision: `Select one option that best describes how involved you want to be with your investment decisions`,
    advisorOnlyOption: `I like to have investment professionals do it for me`,
    togetherWithAdvisorOption: `I like to work with my advisor and select investments together`,
    myselfOnlyOption: `I like to make investment decisions myself`,
    itDependsOption: `It depends on the type or purpose of my account`,
    unsureOption: `I am unsure about this`,
    planningTopicsPageDisclosure: `The My Priorities quiz is meant to help you start a conversation with your financial advisor about what matters most to you. It is intended to be used for illustrative purposes only, and the results will be based on the selections you make. The results are not intended to offer any financial advice, financial planning services, or constitute any recommendations. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within the quiz or results, please contact your branch to discuss.`,
  },
  resultsPage: {
    pageTitle: `My Priorities - Results`,
    howYouRankedHeading: `%CONTACT_FIRSTNAME%, here's how you ranked!`,
    howYouRankedHeadingContactUnkown: `Here's how you ranked!`,
    topThreePriorities: `Your top three priorities:`,
    resultsHeading: `Here is your full list of priorities, ranked in order:`,
    whyTheseHeading: `Why are these priorities important to you?`,
    whyTheseLine1: `Take some time to think about how these priorities made it to the top of your list:`,
    whyTheseLine2: `What does this mean for you and/or your family?`,
    whyTheseLine3: `What is missing from the list that is important to you?`,
    whyTheseLine4: `How do these priorities affect you financially?`,
    nowWhatHeading: `So, what can you do with these results?`,
    nowWhatText: `Now that you’ve identified your top priorities, we can explore them further to learn how they relate to your financial strategy. You can send me/us a copy of your results and together we'll figure out how your top priorities can ladder up to your long-term goals.`,
    nowWhatText2: `Please feel free to reach out if you have any questions or if you’d like to set up a time for us to discuss these results.`,
    faDefaultText: `financial advisor`,
    sendResultsToFA: `Send results to %FA_NAME%`,
    successButton: 'Your results have been sent',
    saveResultsFF: `Go to My Priorities Overview`,
    downloadPdf: `Download as PDF`,
    downloadResults: `Download results`,
    printResults: `Print Results`,
    restartQuiz: `Restart quiz`,
    successMessage: `Thank you for sending your results – they have been shared with your financial advisor.`,
    coldContactSuccessMessage: `Thank you for sending your results – %FA_NAME% will review them and be in touch.`,
    yourFaDefaultText: 'your financial advisor',
    errorMessage: `We ran into a problem trying to send your results. Please download your results and contact your financial advisor.`,
    saveResultsErrorMessage: `We're sorry, we are unable to save your results at this time. Please try again later.`,
    coldContactErrorMessage: `Oh no! We ran into a problem trying to send your results.  Please download your results and contact %FA_FIRSTNAME%.`,
    timestampErrorTitle: '',
    timestampErrorMessage:
      "Sorry we can't automatically send out your results at this time. Please download your results and discuss with your local Financial Advisor, or request a new link.",
    resultsPageDisclosure: `The My Priorities quiz is for illustrative purposes only and based on the selections you have made and may vary depending upon how you answer the questions. The results from the quiz may not account for your unique circumstances and do not constitute a recommendation of any investment or strategy type. This information is not intended to offer any financial advice, and additional factors should be considered when determining your goals and financial strategy. The results will have no impact on your financial strategy until you discuss them with your financial advisor. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within your results, please contact your branch to discuss.`,
    learnMoreButton: `Learn more`,
    learnMoreLink: `https://www.edwardjones.com/preparing-for-your-future/index.html`,
    learnMoreText: `Learn more about how your priorities can ladder up to long-term goals.`,
    pdfErrorMessage: `Something went wrong, please try downloading your results again.`,
    findFAButton: `Find a financial advisor`,
    findFALink: `https://www.edwardjones.com/us-en/search/financial-advisor/results`,
    dndHeading: `All 11 priorities: (in order of importance)`,
    dndMessage: `Don't agree with how they're ranked? Drag and drop them in the order you prefer before downloading or sharing them with us.`,
    whatNext: `What's next?`,
    whatNextSendToFaHeading: `Send your results to %FA_NAME%`,
    whatNextDownloadHeading: `Download your results`,
    whatNextSendToFA: `Share your results with %FA_NAME% to discuss how they relate to your financial strategy.`,
    whatNextDownload: `Save your quiz results to look back on later.`,
    shareQuizHeading: 'Share the My Priorities quiz link',
    shareQuizMessage:
      'Send the quiz to friends or family, then compare your results.',
    copyLinkButton: 'Copy link',
    linkCopiedSuccessfully: 'Link copied',
    copiedUrl: `${window.location.origin}`,
    shareLink: 'Share link:',
    defaultEmailText: `mailto:?subject=I think you'd like the My Priorities quiz&body=Check out this quiz to compare your priorities and how they relate to your financial strategy: ${window.location.origin}`,
    emailButtonTitle: 'Share via email',
    linkedInUrl: `https://linkedin.com/sharing/share-offsite/?url=${window.location.origin}`,
    faceBookUrl: `https://www.facebook.com/share.php?u=${window.location.origin}`,
    socialMediaTitle: 'Share to %APP_NAME%',
  },
  fpResultsPage: {
    pageTitle: `My Priorities - Results`,
    howYouRankedHeading: `%CONTACT_FIRSTNAME%, here are your rankings!`,
    howYouRankedHeadingContactUnkown: `Here are your rankings!`,
    topThreePriorities: `Your top priorities:`,
    resultsHeading: `Here is your full list of priorities, ranked in order:`,
    whyTheseHeading: `Why are these priorities important to you?`,
    whyTheseLine1: `Take some time to think about how these priorities made it to the top of your list:`,
    whyTheseLine2: `What does this mean for you and/or your family?`,
    whyTheseLine3: `What is missing from the list that is important to you?`,
    whyTheseLine4: `How do these priorities affect you financially?`,
    nowWhatHeading: `So, what can you do with these results?`,
    nowWhatText: `Now that you’ve identified your top priorities, we can explore them further to learn how they relate to your financial strategy. You can send me/us a copy of your results and together we'll figure out how your top priorities can ladder up to your long-term goals.`,
    nowWhatText2: `Please feel free to reach out if you have any questions or if you’d like to set up a time for us to discuss these results.`,
    faDefaultText: `financial advisor`,
    sendResultsToFA: `Send results to %FA_NAME%`,
    successButton: 'Your results have been sent',
    saveResultsFF: `Go to My Priorities Overview`,
    downloadPdf: `Download as PDF`,
    downloadResults: `Download results`,
    printResults: `Print Results`,
    restartQuiz: `Restart quiz`,
    successMessage: `Thank you for sending your results – they have been shared with your financial advisor.`,
    coldContactSuccessMessage: `Thank you for sending your results – %FA_NAME% will review them and be in touch.`,
    yourFaDefaultText: 'your financial advisor',
    errorMessage: `We ran into a problem trying to send your results. Please download your results and contact your financial advisor.`,
    saveResultsErrorMessage: `We're sorry, we are unable to save your results at this time. Please try again later.`,
    coldContactErrorMessage: `Oh no! We ran into a problem trying to send your results.  Please download your results and contact %FA_FIRSTNAME%.`,
    timestampErrorTitle: '',
    timestampErrorMessage:
      "Sorry we can't automatically send out your results at this time. Please download your results and discuss with your local Financial Advisor, or request a new link.",
    resultsPageDisclosure: `The My Priorities quiz is for illustrative purposes only and based on the selections you have made and may vary depending upon how you answer the questions. The results from the quiz may not account for your unique circumstances and do not constitute a recommendation of any investment or strategy type. This information is not intended to offer any financial advice or financial planning services, and additional factors should be considered when determining your goals and financial strategy. The results will have no impact on your financial strategy until you discuss them with your financial advisor. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within your results, please contact your branch to discuss.`,
    learnMoreButton: `Learn more`,
    learnMoreLink: `https://www.edwardjones.com/preparing-for-your-future/index.html`,
    learnMoreText: `Learn more about how your priorities can ladder up to long-term goals.`,
    pdfErrorMessage: `Something went wrong, please try downloading your results again.`,
    findFAButton: `Find a financial advisor`,
    findFALink: `https://www.edwardjones.com/us-en/search/financial-advisor/results`,
    dndHeading: `All 11 priorities: (in order of importance)`,
    dndMessage: `Don't agree with how they're ranked? Drag and drop them in the order you prefer before downloading or sharing them with us.`,
    whatNext: `What's next?`,
    whatNextSendToFaHeading: `Send your results to %FA_NAME%`,
    whatNextDownloadHeading: `Download your results`,
    whatNextGetMatchedHeading: `Get Matched with Advisors Near You`,
    whatNextSendToFA: `Share your results with %FA_NAME% to discuss how they relate to your financial strategy.`,
    whatNextDownload: `Save your quiz results to look back on later.`,
    whatNextGetMatched: `Take three minutes to help us understand your needs and goals and match with financial advisors personalized for you.`,
    whatNextMatchLink: `https://match.edwardjones.com/`,
    whatNextMatchButton: `Start Now`,
    shareQuizHeading: 'Share the My Priorities quiz link',
    shareQuizMessage: 'Send the quiz to friends or family.',
    copyLinkButton: 'Copy link',
    linkCopiedSuccessfully: 'Link copied',
    copiedUrl: `${window.location.origin}`,
    shareLink: 'Share link:',
    defaultEmailText: `mailto:?subject=I think you'd like the My Priorities quiz&body=Check out this quiz to compare your priorities and how they relate to your financial strategy: ${window.location.origin}`,
    emailButtonTitle: 'Share via email',
    linkedInUrl: `https://linkedin.com/sharing/share-offsite/?url=${window.location.origin}`,
    faceBookUrl: `https://www.facebook.com/share.php?u=${window.location.origin}`,
    socialMediaTitle: 'Share to %APP_NAME%',
    selectedPlanningTopis: 'Selected Financial Priorities',
    investmentSelection:
      'Based on your investment involvement selection, this statement describes you best:',
    sharedComments: 'What you shared with us:',
    editBtnLabel: 'Edit financial priorities',
  },
  contactFormModal: {
    header: `Share your results with %FA_NAME%`,
    paragraphText: `By providing your name and email, you can share your My Priorities quiz results with %FA_NAME%. They will be in touch to discuss how your priorities can shape your financial strategy.`,
    footerText: `If the advisor you've selected is unavailable, you may hear back from a different Edward Jones financial advisor.`,
    firstNameLabel: 'First Name*',
    lastNameLabel: 'Last Name*',
    missingFirstNameError: 'Please provide your first name',
    missingLastNameError: 'Please provide your last name',
    validFirstNameError:
      'Please provide a valid first name.  It can contain the following characters: ',
    validLastNameError:
      'Please provide a valid last name.  It can contain the following characters: ',
    emailError: 'Please provide a valid email or phone',
    missingEmailError: 'Please provide a valid email',
    phoneError: 'Please provide a valid phone or email',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
    phoneMask: '(999) 999-9999',
    phoneMaskHelperText: '(999) 999-9999',
    validNameChars: "‘’´' -",
    consentLabel:
      'I give Edward Jones permission to contact me by email and/or phone*',
    consentError: 'Please provide consent',
    emailMeLabel: 'Email a copy of results to the email address provided above',
    requiredLabel: '*Email or Phone is required',
    defaultText: 'your financial advisor',
    cancelButton: 'Cancel',
    shareResultsButton: 'Share my results',
  },
  commentModal: {
    header: `%CONTACT_FIRSTNAME%, you are sharing your results with %FA_NAME%.`,
    paragraphOneText: `%FA_NAME% will review your My Priorities quiz results and be in touch.`,
    paragraphTwoText: `Anything else you'd like them to know about these results? Leave a comment below.`,
    label: `Comment (optional)`,
    subTextOne: `Max length: %MAX_LENGTH%`,
    subTextTwo: `Characters left: %CHARS_LEFT%`,
    commentError: `Comments cannot contain: `,
    invalidChars: '`~*^[]{}',
    defaultText: `your financial advisor`,
    cancelButton: 'Cancel',
    shareResultsButton: 'Share my results',
  },
  writeInModal: {
    modalTitle: `Enter a priority`,
    modalTextValuelabel: `Add your own priority to be included in the My Priorities quiz`,
    modalParagraph: `Add your own priority to be included in the My Priorities quiz`,
    modalSubTextOne: `Max length: %MAX_LENGTH%`,
    modalSubTextTwo: `Characters left: %CHARS_LEFT%`,
    modalMissingTextValueError: `Please add a priority.`,
    modalTextValueError: `Value cannot contain numbers or special characters.`,
    cancelButton: 'Cancel',
    submitButton: 'Submit',
    writeInPlaceHolderText: `add your own priority`,
  },
  errorPage: {
    errorTextLine1: `We're sorry, but something went wrong.`,
    errorTextLine2: `We are working to fix it, please try again later.`,
    returnToWelcomePage: `Return to the `,
    welcomePageLinkText: `Welcome Page`,
    fourOhFour: `404: Page Not Found`,
  },
  footer: {
    careersLink: `https://careers.edwardjones.com/`,
    careersText: `Careers`,
    personalFinanceLink: `https://www.edwardjones.com/hidden-assets/active-blog-articles.html`,
    personalFinanceText: `Personal Finance`,
    feedbackLink: `https://www.edwardjones.com/feedback-form.html`,
    feedbackText: `Feedback`,
    privacyLink: `https://www.edwardjones.com/privacy/index.html`,
    privacyText: `Privacy`,
    revenueSharingLink: `https://www.edwardjones.com/sites/default/files/acquiadam/2021-02/revenue-sharing-disclosure.pdf`,
    revenueSharingText: `Revenue Sharing (pdf)`,
    formCrsLink: `https://www.edwardjones.com/us-en/disclosures/best-interest-relationship-summary`,
    formCrsText: `Form CRS`,
    disclosuresLink: `https://www.edwardjones.com/disclosures/index.html`,
    disclosuresText: `Disclosures`,
    accessibilityLink: `https://www.edwardjones.com/us-en/accessibility-policy`,
    accessibilityText: `Accessibility Policy`,
    copyrightParagraph: `Copyright © %CURRENT_YEAR% Edward Jones. All rights reserved. Member `,
    sipcLink: `https://www.sipc.org/`,
    sipcText: `SIPC`,
    disclaimerParagraph: `This site is designed for U.S. residents only. The services offered within this site are available exclusively through our U.S. financial advisors. Edward Jones' U.S. financial advisors may only conduct business with residents of the states for which they are properly registered. Please note that not all of the investments and services mentioned are available in every state.`,
  },
};

const enCA = {
  header: {
    title: `My Priorities Quiz`,
    link: `https://www.edwardjones.ca`,
  },
  app: {
    skipLinkText: 'Skip to main content',
    customizePath: '/customize',
    quizPath: '/quiz',
    resultsPath: '/results',
    errorPath: '/error',
    planningPath: '/planning',
  },
  LanguageSelect: {
    languageSelectLabel: 'Country: ',
    languageSelectTexts: 'Canada | English,Canada | Français',
    languageSelectTextDefault: 'Canada | English',
    languageDialogCancel: 'Cancel/Annuler',
    languageDialogLeave: 'Leave/Sortir',
    languageDialogTitle2: 'Vous perdrez votre progression.',
    languageDialogTitle1: 'You will lose your quiz progress.',
    languageDialogQuestion1: 'Do you want to leave your quiz?',
    languageDialogQuestion2: 'Que souhaitez-vous sortir du questionnaire?',
  },
  defaultDisclosure: `The My Priorities quiz is meant to help you start a conversation with your financial advisor about what matters most to you. It is intended to be used for illustrative purposes only, and the results will be based on the selections you make. The results are not intended to offer any financial advice or constitute any recommendations. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within the quiz or results, please contact your branch to discuss.`,
  styleModalButton: `Okay, got it!`,
  welcomePage: {
    pageTitle: `My Priorities - Home`,
    header: `Welcome`,
    introPa: `The "My Priorities" quiz helps you compare your priorities.   The results help us get to know you better and dig deeper into the "whys."`,
    customizeInstr: `This three-minute quiz begins with customizing your choices to remove priorities least relevant to you. The quiz will then show you two priorities at a time, and you'll select the one that matters most to you. You may encounter two that feel equally important or some that don't feel applicable at all – but don't worry. What you value most will rise to the top.`,
    startBtnLabel: `Start the quiz`,
    customizeBtnLabel: `Customize your quiz`,
    welcomePageDisclosure: `The My Priorities quiz is meant to help you start a conversation with your financial advisor about what matters most to you. It is intended to be used for illustrative purposes only, and the results will be based on the selections you make. The results are not intended to offer any financial advice or constitute any recommendations. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within the quiz or results, please contact your branch to discuss.`,
  },
  customizePage: {
    pageTitle: `My Priorities - Customize Quiz`,
    header: `Customize your quiz`,
    description: `Deselect five of the below priorities that are least relevant to you. The quiz uses exactly 11 priorities, so you'll remove exactly five to start the quiz.`,
    startQuiz: `Next`,
    disabledBtnDefault: `Remove 5 more`,
    disabledBtnRemove: `Remove`,
    disabledBtnAdd: `Add`,
    disabledBtnMore: `more`,
    iconButton: 'Why 11?',
    modalTitle: `Why do I need exactly 11 priorities to start the quiz?`,
    modalParagraph1: `You may see more than 11 priorities that you value or you may see less. That's okay!`,
    modalParagraph2: `In order for our quiz to give you your most accurate ranking, it has to have exactly 11, so go with your gut, and do your best to narrow it down to that magic number.`,
    customPriorityInfoModalTitle: `Provide your own customized priority to be included in the quiz.`,
    writeInPlaceHolderText: `add your own priority`,
  },
  modalTitle: 'How does this quiz work?',
  modalParagraph1:
    "You'll compare two priorities by selecting the one that matters most to you. You may see priorities appear more than once or you may have to choose between two that feel equally important or may not be applicable right now - don't worry. What you value the most will rise to the top.",
  modalParagraph2:
    "It takes about 25 clicks to complete the quiz. When you're done, your financial advisor and you can discuss how your top priorities can ladder up to your long-term goals.",
  quizPage: {
    pageTitle: `My Priorities - Quiz`,
    header: `Which is a higher priority to you?`,
    tooltipDescription: `Compare the scenarios and click the square that feels more important to you. It's okay if neither one feels applicable. Just choose one and keep going. And don't worry if you see a priority appear more than once - that's how we get to what's most important to you.`,
    chooseOneBoldText: `Choose one priority. `,
    goWithText: `Go with your first reaction! Try to choose in less than 10 seconds.`,
    quizPageDisclosure: `The My Priorities quiz is meant to help you start a conversation with your financial advisor about what matters most to you. It is intended to be used for illustrative purposes only, and the results will be based on the selections you make. The results are not intended to offer any financial advice or constitute any recommendations. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within the quiz or results, please contact your branch to discuss.`,
    ariaLabelChoiceNumberOne: `Choice number one is `,
    ariaLabelChoiceNumberTwo: `Choice number two is `,
    changePreviousAnswerButtonLabel: `Change Previous Answer`,
    changePreviousAnswerAriaLabel: `Change Previous Answer`,
    progressBarAriaLabel: `Question %QUESTION_NUMBER% of %MAX_QUESTIONS%.`,
  },
  resultsPage: {
    pageTitle: `My Priorities - Results`,
    youDidItText: `Based on your selections, here are your top three priorities.`,
    howYouRankedHeading: `%CONTACT_FIRSTNAME%, here's how you ranked!`,
    howYouRankedHeadingContactUnkown: `Here's how you ranked!`,
    topThreePriorities: `Your top three priorities:`,
    resultsHeading: `Here is your full list of priorities, ranked in order:`,
    whyTheseHeading: `Why are these priorities important to you?`,
    whyTheseLine1: `Take some time to think about how these priorities made it to the top of your list:`,
    whyTheseLine2: `What does this mean for you and/or your family?`,
    whyTheseLine3: `What is missing from the list that is important to you?`,
    whyTheseLine4: `How do these priorities affect you financially?`,
    nowWhatHeading: `So, what can you do with these results?`,
    nowWhatText: `Now that you’ve identified your top priorities, we can explore them further to learn how they relate to your financial strategy. You can send me/us a copy of your results and together we'll figure out how your top priorities can ladder up to your long-term goals.`,
    nowWhatText2: `Please feel free to reach out if you have any questions or if you’d like to set up a time for us to discuss these results.`,
    faDefaultText: `financial advisor`,
    sendResultsToFA: `Send results to %FA_NAME%`,
    successButton: 'Your results have been sent',
    saveResultsFF: `Go to My Priorities Overview`,
    downloadPdf: `Download as PDF`,
    downloadResults: `Download results`,
    printResults: `Print Results`,
    restartQuiz: `Restart quiz`,
    successMessage: `Thank you for sending your results – they have been shared with your financial advisor.`,
    saveResultsErrorMessage: `We're sorry, we are unable to save your results at this time. Please try again later.`,
    coldContactSuccessMessage: `Thank you for sending your results – %FA_NAME% will review them and be in touch.`,
    yourFaDefaultText: 'your financial advisor',
    errorMessage: `We ran into a problem trying to send your results. Please download your results and contact your financial advisor.`,
    coldContactErrorMessage: `Oh no! We ran into a problem trying to send your results.  Please download your results and contact %FA_FIRSTNAME%.`,
    timestampErrorTitle: '',
    timestampErrorMessage:
      "Sorry we can't automatically send out your results at this time. Please download your results and discuss with your local Financial Advisor, or request a new link.",
    resultsPageDisclosure: `The My Priorities quiz is for illustrative purposes only and based on the selections you have made and may vary depending upon how you answer the questions. The results from the quiz may not account for your unique circumstances and do not constitute a recommendation of any investment or strategy type. This information is not intended to offer any financial advice, and additional factors should be considered when determining your goals and financial strategy. The results will have no impact on your financial strategy until you discuss them with your financial advisor. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within your results, please contact your branch to discuss.`,
    learnMoreButton: `Learn more`,
    learnMoreLink: `https://www.edwardjones.ca/preparing-for-your-future/index.html`,
    learnMoreText: `Learn more about how your priorities can ladder up to long-term goals.`,
    pdfErrorMessage: `Something went wrong, please try downloading your results again.`,
    findFAButton: `Find a financial advisor`,
    findFALink: `https://www.edwardjones.ca/ca-en/search/financial-advisor/results?query=&distance=50&page=1&view=list`,
    dndHeading: `All 11 priorities: (in order of importance)`,
    dndMessage: `Don't agree with how they're ranked? Drag and drop them in the order you prefer before downloading or sharing them with us.`,
    whatNext: `What's next?`,
    whatNextSendToFaHeading: `Send your results to %FA_NAME%`,
    whatNextDownloadHeading: `Download your results`,
    whatNextSendToFA: `Share your results to %FA_NAME% to discuss how they relate to your financial strategy.`,
    whatNextDownload: `Save your quiz results to look back on later.`,
    shareQuizHeading: 'Share the My Priorities quiz link',
    shareQuizMessage:
      'Send the quiz to friends or family, then compare your results.',
    copyLinkButton: 'Copy link',
    linkCopiedSuccessfully: 'Link copied',
    copiedUrl: 'https://mypriorities.edwardjones.ca/',
    shareLink: 'Share link:',
    defaultEmailText: `mailto:?subject=I think you'd like the My Priorities quiz&body=Check out this quiz to compare your priorities and how they relate to your financial strategy: ${window.location.origin}`,
    emailButtonTitle: 'Share via email',
    linkedInUrl: `https://linkedin.com/sharing/share-offsite/?url=${window.location.origin}`,
    faceBookUrl: `https://www.facebook.com/share.php?u=${window.location.origin}`,
    socialMediaTitle: 'Share to %APP_NAME%',
  },
  contactFormModal: {
    header: `Share your results with %FA_NAME%`,
    paragraphText: `By providing your name and email, you can share your My Priorities quiz results with %FA_NAME%. They will be in touch to discuss how your priorities can shape your financial strategy.`,
    footerText: `If the advisor you've selected is unavailable, you may hear back from a different Edward Jones financial advisor.`,
    firstNameLabel: 'First Name*',
    lastNameLabel: 'Last Name*',
    missingFirstNameError: 'Please provide your first name',
    missingLastNameError: 'Please provide your last name',
    validFirstNameError:
      'Please provide a valid first name.  It can contain the following characters: ',
    validLastNameError:
      'Please provide a valid last name.  It can contain the following characters: ',
    emailError: 'Please provide a valid email or phone',
    missingEmailError: 'Please provide a valid email',
    phoneError: 'Please provide a valid phone or email',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
    phoneMask: '(999) 999-9999',
    phoneMaskHelperText: '(999) 999-9999',
    validNameChars: "‘’´' -",
    consentLabel:
      'I give Edward Jones permission to contact me by email and/or phone*',
    consentError: 'Please provide consent',
    emailMeLabel: 'Email a copy of results to the email address provided above',
    requiredLabel: '*Email or Phone is required',
    defaultText: 'your financial advisor',
    cancelButton: 'Cancel',
    shareResultsButton: 'Share my results',
  },
  commentModal: {
    header: `%CONTACT_FIRSTNAME%, you are sharing your results with %FA_NAME%.`,
    paragraphOneText: `%FA_NAME% will review your My Priorities quiz results and be in touch.`,
    paragraphTwoText: `Anything else you'd like them to know about these results? Leave a comment below.`,
    label: `Comment (optional)`,
    subTextOne: `Max length: %MAX_LENGTH%`,
    subTextTwo: `Characters left: %CHARS_LEFT%`,
    commentError: `Comments cannot contain: `,
    invalidChars: '`~*^[]{}',
    defaultText: 'your financial advisor',
    cancelButton: 'Cancel',
    shareResultsButton: 'Share my results',
  },
  writeInModal: {
    modalTitle: `Enter a priority`,
    modalTextValuelabel: `Add your own priority to be included in the My Priorities quiz`,
    modalParagraph: `Add your own priority to be included in the My Priorities quiz`,
    modalSubTextOne: `Max length: %MAX_LENGTH%`,
    modalSubTextTwo: `Characters left: %CHARS_LEFT%`,
    modalMissingTextValueError: `Please add a priority.`,
    modalTextValueError: `Value cannot contain numbers or special characters.`,
    cancelButton: 'Cancel',
    submitButton: 'Submit',
    writeInPlaceHolderText: `add your own priority`,
  },
  errorPage: {
    errorTextLine1: `We're sorry, but something went wrong.`,
    errorTextLine2: `We are working to fix it, please try again later.`,
    returnToWelcomePage: `Return to the `,
    welcomePageLinkText: `Welcome Page`,
    fourOhFour: `404: Page Not Found`,
  },
  footer: {
    careersLink: `https://careers.edwardjones.ca/`,
    careersText: `Careers`,
    feedbackLink: `https://www.edwardjones.ca/feedback-form.html`,
    feedbackText: `Feedback`,
    privacyLink: `https://www.edwardjones.ca/disclosures/account-protection-privacy/privacy-notice.html`,
    privacyText: `Privacy`,
    disclosuresLink: `https://www.edwardjones.ca/disclosures/index.html`,
    disclosuresText: `Disclosures`,
    accessibilityLink: `https://www.edwardjones.ca/ca-en/accessibility-policy`,
    accessibilityText: `Accessibility Policy`,
    member: `Member - `,
    CIPFLink: `https://www.cipf.ca/`,
    CIPFText: `Canadian Investor Protection Fund`,
    member2: `. Member - `,
    IIROCLink: `https://www.ciro.ca/`,
    IIROCText: `Canadian Investment Regulatory Organization`,
    line1: `Welcome to the Edward Jones Website. This site is published in Canada exclusively for residents of Canadian jurisdictions where our products and services may be legally offered. The services offered within this site are available exclusively through our Canadian advisors. Edward Jones' Canadian advisors may only conduct business with residents of the province(s) in which they are registered.`,
    line2: `Copyright © %CURRENT_YEAR% Edward D. Jones & Co., L.P. Single copies of our Internet pages may be downloaded or printed solely for personal use. It is otherwise prohibited to modify, copy, distribute, transmit, display, perform, reproduce, publish, license, create derivative works from, transfer, or sell any information, software, products or services obtained from this site. Edward Jones® is a registered trademark of Edward D. Jones & Co., L.P.`,
    line3: `Edward Jones is a limited partnership in Canada and is a wholly owned subsidiary of Edward D. Jones & Co., LP, a Missouri limited partnership. Edward D. Jones & Co., LP is a wholly owned subsidiary of The Jones Financial Companies, LLLP, a limited liability limited partnership.`,
    line4: `Edward Jones and its independent affiliate in the United States, collectively, serve nearly 7 million investors.`,
    line5: `*In Quebec, our advisors are known as Investment Advisors.`,
  },
};

const frCA = {
  header: {
    title: `Questionnaire «\xa0\xa0Mes priorités\xa0\xa0»`,
    link: `https://www.edwardjones.ca/ca-fr`,
  },
  app: {
    skipLinkText: 'Passer au contenu principal',
    customizePath: '/customisez',
    quizPath: '/questionnaire',
    resultsPath: '/resultats',
    errorPath: '/erreur',
    planningPath: '/planning',
  },
  LanguageSelect: {
    languageSelectLabel: 'Pays: ',
    languageSelectTexts: 'Canada | English,Canada | Français',
    languageSelectTextDefault: 'Canada | Français',
    languageDialogCancel: 'Annuler/Cancel',
    languageDialogLeave: 'Sortir/Leave',
    languageDialogTitle2: 'You will lose your quiz progress.',
    languageDialogTitle1: 'Vous perdrez votre progression.',
    languageDialogQuestion1: 'Que souhaitez-vous sortir du questionnaire',
    languageDialogQuestion2: 'Do you want to leave your quiz?',
  },
  defaultDisclosure: `Le questionnaire «\xa0\xa0Mes priorités\xa0\xa0» a pour but de vous aider à engager une conversation avec votre conseiller en investissement à propos de ce qui est le plus important pour vous. Il est destiné à être utilisé à titre purement illustratif, et les résultats seront basés sur les choix que vous ferez. Les résultats ne sont pas destinés à fournir des conseils financiers ni à donner une quelconque recommandation. Le questionnaire «\xa0\xa0Mes priorités\xa0\xa0» ne reflète pas toutes les priorités possibles dans votre situation. Si vous pensez avoir une priorité qui n’est pas reflétée dans le questionnaire ou les résultats, veuillez prendre contact avec votre succursale pour en discuter.`,
  styleModalButton: `Allons-y!`,
  welcomePage: {
    pageTitle: `Mes priorités - accueil`,
    header: `Bienvenue`,
    introPa: `Le questionnaire «\xa0\xa0Mes priorités\xa0\xa0» vous aide à comparer vos priorités. Les résultats nous aident à mieux vous connaître et à approfondir les pourquois.`,
    customizeInstr: `Ce questionnaire de trois minutes commence par la personnalisation de vos choix afin de supprimer les priorités les moins pertinentes pour vous. Le questionnaire vous montrera ensuite deux priorités à la fois et vous choisirez celle qui compte le plus pour vous. Il se peut que vous en rencontriez deux qui paraissent aussi importantes l’une que l’autre ou certaines qui ne vous semblent pas applicables du tout – mais ne vous inquiétez pas. Ce qui vous importe le plus se retrouvera au premier plan.`,
    startBtnLabel: `Commencer le questionnaire`,
    customizeBtnLabel: `Personnalisez votre questionnaire`,
    welcomePageDisclosure: `Le questionnaire «\xa0\xa0Mes priorités\xa0\xa0» a pour but de vous aider à engager une conversation avec votre conseiller en investissement à propos de ce qui est le plus important pour vous. Il est destiné à être utilisé à titre purement illustratif, et les résultats seront basés sur les choix que vous ferez. Les résultats ne sont pas destinés à fournir des conseils financiers ni à donner une quelconque recommandation. Le questionnaire «\xa0\xa0Mes priorités\xa0\xa0» ne reflète pas toutes les priorités possibles dans votre situation. Si vous pensez avoir une priorité qui n’est pas reflétée dans le questionnaire ou les résultats, veuillez prendre contact avec votre succursale pour en discuter.`,
  },
  customizePage: {
    pageTitle: `Mes priorités - personnalisez`,
    header: `Personnalisez votre questionnaire`,
    description: `Sélectionnez cinq des priorités ci-dessous qui sont les moins pertinentes pour vous. Le questionnaire utilise exactement 11 priorités, vous devrez donc en retirer exactement cinq pour commencer le questionnaire.`,
    startQuiz: `Suivant`,
    disabledBtnDefault: `Retirez 5 de plus`,
    disabledBtnRemove: `Retirez`,
    disabledBtnAdd: `Ajoutez`,
    disabledBtnMore: `de plus`,
    iconButton: 'Pourquoi 11?',
    modalTitle: `Pourquoi faut-il exactement 11 priorités pour lancer le questionnaire?`,
    modalParagraph1: `Il se peut que vous voyiez plus de 11 priorités auxquelles vous accordez de l’importance ou que vous en voyiez moins. D’accord!`,
    modalParagraph2: `Pour que notre questionnaire vous donne le classement le plus précis, il doit comporter exactement 11 éléments, alors fiez-vous à votre instinct et faites de votre mieux pour le ramener à ce chiffre magique.`,
    customPriorityInfoModalTitle: `Indiquez votre priorité personnalisée à inclure dans le questionnaire.`,
    writeInPlaceHolderText: `ajoutez votre propre priorité`,
  },
  modalTitle: 'Comment ce questionnaire fonctionne-t-il?',
  modalParagraph1:
    'Vous comparerez deux priorités en sélectionnant celle qui vous semble la plus importante. Il se peut que vous voyiez des priorités apparaître plus d’une fois ou que vous deviez choisir entre deux qui vous semblent aussi importantes l’une que l’autre ou qui ne sont pas nécessairement applicables dans l’immédiat – ne vous inquiétez pas. Ce qui vous importe le plus se retrouvera au premier plan.',
  modalParagraph2:
    'Il faut environ 25 étapes pour compléter le questionnaire. Lorsque vous aurez terminé, votre conseiller en investissement et vous pourrez discuter de la manière dont vos principales priorités peuvent vous permettre d’atteindre vos objectifs à long terme.',
  quizPage: {
    pageTitle: `Mes priorités - questionnaire`,
    header: `Quelle est la priorité la plus importante pour vous?`,
    tooltipDescription: `Comparez les scénarios et cochez la case qui vous semble la plus importante. Ce n’est pas grave si aucun des deux ne semble pertinent. Choisissez-en une et continuez. Et ne vous inquiétez pas si une même priorité apparaît plus qu’une fois – c’est ainsi que nous arrivons à ce qui est le plus important pour vous.`,
    chooseOneBoldText: `Choisissez une priorité. `,
    goWithText: `Allez-y avec votre premier instinct! Faites un choix en moins de 10 secondes.`,
    quizPageDisclosure: `Le questionnaire «\xa0\xa0Mes priorités\xa0\xa0» a pour but de vous aider à engager une conversation avec votre conseiller en investissement à propos de ce qui est le plus important pour vous. Il est destiné à être utilisé à titre purement illustratif, et les résultats seront basés sur les choix que vous ferez. Les résultats ne sont pas destinés à fournir des conseils financiers ni à donner une quelconque recommandation. Le questionnaire «\xa0\xa0Mes priorités\xa0\xa0» ne reflète pas toutes les priorités possibles dans votre situation. Si vous pensez avoir une priorité qui n’est pas reflétée dans le questionnaire ou les résultats, veuillez prendre contact avec votre succursale pour en discuter.`,
    ariaLabelChoiceNumberOne: `Le premier choix est `,
    ariaLabelChoiceNumberTwo: `Le deuxième choix est `,
    changePreviousAnswerButtonLabel: `Modifier la réponse précédente`,
    changePreviousAnswerAriaLabel: `Modifier la réponse précédente`,
    progressBarAriaLabel: `Question %QUESTION_NUMBER% de %MAX_QUESTIONS%.`,
  },
  resultsPage: {
    pageTitle: `Mes priorités - résultats`,
    youDidItText: `D’après choix, voici vos trois principales priorités.`,
    howYouRankedHeading: `%CONTACT_FIRSTNAME%, voici votre classement!`,
    howYouRankedHeadingContactUnkown: `Voici votre classement!`,
    topThreePriorities: `Vos trois principales priorités\xa0:`,
    resultsHeading: `Voici la liste complète de vos priorités classées selon leur rang\xa0:`,
    whyTheseHeading: `Pourquoi ces priorités sont-elles importantes pour vous?`,
    whyTheseLine1: `Prenez le temps de réfléchir à la raison pour laquelle ces priorités se sont retrouvées en tête de liste\xa0:`,
    whyTheseLine2: `Qu’est-ce que cela signifie pour vous et votre famille?`,
    whyTheseLine3: `Qu’est-ce qui manque dans la liste et qui a de l’importance pour vous?`,
    whyTheseLine4: `Quel impact ces priorités ont-elles sur votre situation financière?`,
    nowWhatHeading: `Et maintenant, que pouvez-vous faire avec ces résultats?`,
    nowWhatText: `Maintenant que vous avez déterminé vos principales priorités, nous pouvons les explorer davantage pour mieux comprendre leur lien avec votre stratégie financière. Vous pouvez me/nous faire parvenir une copie de vos résultats et, ensemble, nous pourrons comment vos principales priorités peuvent vous permettre d’atteindre vos objectifs à long terme.`,
    nowWhatText2: `N’hésitez pas à communiquer avec nous si vous avez des questions ou pour prendre rendez-vous afin de discuter de ces résultats.`,
    faDefaultText: `un conseiller en investissement`,
    sendResultsToFA: `Envoyer les résultats à %FA_NAME%`,
    successButton: 'Vos résultats ont été envoyés',
    saveResultsFF: `Go to My Priorities Overview`,
    downloadPdf: `Téléchargez en format PDF`,
    downloadResults: `Téléchargez les résultats`,
    printResults: `Imprimer les résultats`,
    restartQuiz: `Redémarrer le questionnaire`,
    successMessage: `Merci d’avoir envoyé vos résultats – ils ont été communiqués à votre conseiller en investissement.`,
    saveResultsErrorMessage: `Nous sommes désolés, mais nous ne sommes pas en mesure d’enregistrer vos résultats pour le moment. Veuillez réessayer plus tard.`,
    coldContactSuccessMessage: `Merci d’avoir envoyé vos résultats – %FA_NAME% en prendra connaissance et communiquera avec vous.`,
    yourFaDefaultText: 'votre conseiller en investissement',
    errorMessage: `Nous avons rencontré un problème lors de l’envoi de vos résultats. Veuillez téléchargez vos résultats et communiquer avec votre conseiller en investissement.`,
    coldContactErrorMessage: `Oh, non! Nous avons rencontré un problème lors de l’envoi de vos résultats. Veuillez téléchargez vos résultats et communiquer avec %FA_FIRSTNAME%.`,
    timestampErrorTitle: '',
    timestampErrorMessage:
      'Nous sommes désolés, mais il nous est impossible d’envoyer vos résultats automatiquement pour le moment. Veuillez téléchargez vos résultats pour en discuter avec votre conseiller en investissement local ou demandez un nouveau lien.',
    resultsPageDisclosure: `Le questionnaire «\xa0\xa0Mes priorités\xa0\xa0» a pour but de vous aider à engager une conversation avec votre conseiller en investissement à propos de ce qui est le plus important pour vous. Il est destiné à être utilisé à titre purement illustratif, et les résultats seront basés sur les choix que vous ferez. Les résultats ne sont pas destinés à fournir des conseils financiers ni à donner une quelconque recommandation. Le questionnaire «\xa0\xa0Mes priorités\xa0\xa0» ne reflète pas toutes les priorités possibles dans votre situation.  Si vous pensez avoir une priorité qui n’est pas reflétée dans le questionnaire ou les résultats, veuillez prendre contact avec votre succursale pour en discuter.`,
    learnMoreButton: `En savoir plus`,
    learnMoreLink: `https://www.edwardjones.ca/ca-fr/pourquoi-choisir-edward-jones/notre-approche-en-matiere-de-placement`,
    learnMoreText: `Apprenez-en davantage sur la façon dont vos priorités peuvent vous permettre d’atteindre vos objectifs à long terme.`,
    pdfErrorMessage: `Un problème est survenu; veuillez réessayer de téléchargez vos résultats.`,
    findFAButton: `Trouver un conseiller en investissement`,
    findFALink: `https://www.edwardjones.ca/ca-fr/search/financial-advisor/results`,
    dndHeading: `Les 11 priorités\xa0: (par ordre d’importance)`,
    dndMessage: `Vous n’êtes pas d’accord avec la façon dont elles sont classées? Faites-les glisser et déposez-les dans l’ordre que vous préférez avant de les télécharger ou de les partager avec nous.`,
    whatNext: `Quelle est la prochaine étape?`,
    whatNextSendToFaHeading: `Envoyez vos résultats à %FA_NAME%`,
    whatNextDownloadHeading: `Téléchargez vos résultats`,
    whatNextSendToFA: `Veuillez envoyer vos résultats à %FA_NAME% pour discuter de leur lien avec votre stratégie financière.`,
    whatNextDownload: `Enregistrez vos résultats du questionnaire pour y revoir vos priorités.`,
    shareQuizHeading:
      'Partagez le lien vers le questionnaire «\xa0\xa0Mes priorités\xa0\xa0»',
    shareQuizMessage:
      'Envoyez le questionnaire à vos amis ou à votre famille et comparez vos résultats.',
    copyLinkButton: 'Copier le lien',
    linkCopiedSuccessfully: 'Lien copié',
    copiedUrl: 'https://mespriorites.edwardjones.ca',
    shareLink: 'Partager le lien\xa0:',
    defaultEmailText: `mailto:?subject=Je crois que le questionnaire «\xa0\xa0Mes priorités\xa0\xa0» pourrait vous intéresser.&body=Utilisez ce questionnaire pour comparer vos priorités et examiner leur lien avec votre stratégie financière\xa0: ${window.location.origin}`,
    emailButtonTitle: 'Partager par courriel',
    linkedInUrl: `https://linkedin.com/sharing/share-offsite/?url=${window.location.origin}`,
    faceBookUrl: `https://www.facebook.com/share.php?u=${window.location.origin}`,
    socialMediaTitle: 'Partager sur %APP_NAME%',
  },
  contactFormModal: {
    header: `Partagez vos résultats avec %FA_NAME%`,
    paragraphText: `En indiquant votre nom et votre adresse courriel, vous pouvez partager vos résultats du questionnaire «\xa0\xa0Mes priorités\xa0\xa0» avec %FA_NAME%. Ce conseiller communiquera avec vous pour discuter de la façon dont vos priorités peuvent orienter votre stratégie financière.`,
    footerText: `Si le conseiller que vous avez choisi n’est pas disponible, il est possible qu’un autre conseiller en investissement Edward Jones communique avec vous.`,
    firstNameLabel: 'Prénom*',
    lastNameLabel: 'Nom de famille*',
    missingFirstNameError: 'Veuillez entrer votre prénom',
    missingLastNameError: 'Veuillez entrer votre nom de famille',
    validFirstNameError:
      'Veuillez entrer votre prénom. Vous pouvez utiliser les caractères suivants\xa0: ',
    validLastNameError:
      'Veuillez entrer votre nom de famille. Vous pouvez utiliser les caractères suivants\xa0: ',
    emailError:
      'Veuillez fournir une adresse courriel ou un numéro de téléphone valide',
    missingEmailError: 'Veuillez fournir une adresse courriel valide',
    phoneError:
      'Veuillez fournir une adresse courriel ou un numéro de téléphone valide',
    emailLabel: 'Adresse courriel',
    phoneLabel: 'Téléphone',
    phoneMask: '(999) 999-9999',
    phoneMaskHelperText: '(999) 999-9999',
    validNameChars: "‘’´' -",
    consentLabel:
      'J’autorise Edward Jones à communiquer avec moi par courriel ou par téléphone*',
    consentError: 'Veuillez donner votre consentement',
    emailMeLabel:
      'Envoyez une copie des résultats par courriel à l’adresse indiquée ci-dessus',
    requiredLabel: '*Adresse courriel ou numéro de téléphone requis',
    defaultText: 'votre conseiller en investissement',
    cancelButton: 'Annuler',
    shareResultsButton: 'Partager mes résultats',
  },
  commentModal: {
    header: `%CONTACT_FIRSTNAME%, vous partagez vos résultats avec %FA_NAME%.`,
    paragraphOneText: `%FA_NAME% passera en revue les résultats de votre questionnaire «\xa0\xa0Mes priorités\xa0\xa0» et communiquera avec vous.`,
    paragraphTwoText: `Y a-t-il autre chose que vous aimeriez qu’il sache à propos de ces résultats? Laissez un commentaire ci-dessous.`,
    label: `Commentaire (facultatif)`,
    subTextOne: `Longueur maximum\xa0: %MAX_LENGTH%`,
    subTextTwo: `Caractères restants\xa0: %CHARS_LEFT%`,
    commentError: `Les commentaires ne peuvent pas contenir\xa0: `,
    invalidChars: '`~*^[]{}',
    defaultText: 'votre conseiller en investissement',
    cancelButton: 'Annuler',
    shareResultsButton: 'Partager mes résultats',
  },
  writeInModal: {
    modalTitle: `Entrez une priorité`,
    modalTextValuelabel: `Ajoutez votre propre priorité à inclure dans le questionnaire «\xa0\xa0Mes priorités\xa0\xa0»`,
    modalParagraph: `Ajoutez votre propre priorité à inclure dans le questionnaire «\xa0\xa0Mes priorités\xa0\xa0»`,
    modalSubTextOne: `Longueur maximum\xa0: %MAX_LENGTH%`,
    modalSubTextTwo: `Caractères restants\xa0: %CHARS_LEFT%`,
    modalMissingTextValueError: `Veuillez ajouter un priorité.`,
    modalTextValueError: `La valeur ne peut contenir ni chiffres ni caractères spéciaux.`,
    cancelButton: 'Annuler',
    submitButton: 'Soumettre',
    writeInPlaceHolderText: `ajoutez votre propre priorité`,
  },
  errorPage: {
    errorTextLine1: `Nous sommes désolés, mais un problème est survenu.`,
    errorTextLine2: `Nous travaillons à le résoudre. Veuillez réessayer plus tard.`,
    returnToWelcomePage: `Retour à la `,
    welcomePageLinkText: `Page d’accueil`,
    fourOhFour: `404: Page non trouvée`,
  },
  footer: {
    careersLink: `https://careers.edwardjones.com/fr-CA/`,
    careersText: `Carrières`,
    feedbackLink: `https://www.edwardjones.ca/ca-fr/nous-contacter`,
    feedbackText: `Commentaires`,
    privacyLink: `https://www.edwardjones.ca/ca-fr/divulgations/protection-du-compte-et-confidentialite/avis-de-confidentialite`,
    privacyText: `Confidentialité`,
    disclosuresLink: `https://www.edwardjones.ca/ca-fr/divulgations`,
    disclosuresText: `Divulgations`,
    accessibilityLink: `https://www.edwardjones.ca/ca-fr/politique-surlaccessibilite`,
    accessibilityText: `Politique sur l’accessibilité`,
    member: `Membre - `,
    CIPFLink: `https://www.fcpi.ca/accueil`,
    CIPFText: `le Fonds canadien de protection des épargnants`,
    member2: `. Membre - `,
    IIROCLink: `https://www.ocri.ca/`,
    IIROCText: `Organisme canadien de réglementation des investissements`,
    line1: `Bienvenue au site Web Edward Jones. Ce site est publié au Canada uniquement à l'intention des résidents des compétences territoriales du Canada où la loi nous autorise à offrir nos produits et services. Les services offerts dans ce site peuvent être obtenus exclusivement par l'entremise des conseillers en investissement Edward Jones du Canada, lesquels ne peuvent entrer en relation d'affaires qu'avec les résidents de la ou des provinces où ils sont autorisés.`,
    line2: `Tous droits réservés © %CURRENT_YEAR% Edward D. Jones & Co., L.P. Des copies uniques de nos pages Internet peuvent être téléchargées ou imprimées pour usage personnel seulement. Autrement, il est interdit de modifier, copier, distribuer, transmettre, afficher, exécuter, reproduire, publier, céder ou consentir une licence, créer des œuvres dérivées à partir de, transférer ou vendre toute information, tout logiciel, tout produit ou service obtenu à partir de ce site.`,
    line3: `Edward Jones, société en commandite établie au Canada, est une filiale en propriété exclusive de Edward D. Jones & Co., LP, société en commandite du Missouri. Edward D. Jones & Co., L.P. est une filiale en propriété exclusive de The Jones Financial Companies, LLLP, une société en commandite à responsabilité limitée.`,
    line4: `Edward Jones MD est une marque déposée de Edward D. Jones & Co., L.P. Edward Jones et sa société affiliée indépendante aux États-Unis desservent ensemble près de 7 millions d'investisseurs.`,
    line5: `*Au Québec, nos conseillers sont désignés sous le nom de conseillers en investissement.`,
  },
};

/**
 * getText returns static text based on locale ID
 * @param {string} locId - the locale Id of the user taking the quiz
 * @param {string} component - the component to be populated with the return text
 * @param {string} [page] - OPTIONAL - page where the component lives
 * @returns {string} - Text to be populated in the specific component
 */
export default function getText(
  locId: string,
  component: string,
  page: string
): string {
  switch (locId) {
    case 'en_US':
      return page
        ? enUS[page as keyof object][component as keyof object]
        : enUS[component as keyof object];
    case 'en_CA':
      return page
        ? enCA[page as keyof object][component as keyof object]
        : enCA[component as keyof object];
    case 'fr_CA':
      return page
        ? frCA[page as keyof object][component as keyof object]
        : frCA[component as keyof object];
    default:
      return page
        ? enUS[page as keyof object][component as keyof object]
        : enUS[component as keyof object];
  }
}
